import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'
import { Roles } from '@cbgms/api/modules/enums'
import { RolePermissions } from './Roles'
import { NewPermissionSuite } from '@cbgms/base/permissions/permissionsUtils'

const useUserPermissionProviderByRole = (): string[] => {
  const role = useSelector<IRootReducerState, Roles>(state => state.auth.user['custom:role'])
  const permissions = RolePermissions[role] || []
  return permissions
}

const suite = NewPermissionSuite(useUserPermissionProviderByRole)
export const RequiredPermission = suite.RequiredPermission
export const usePermissionsChecker = suite.usePermissionsChecker
export const useHasPermission = suite.useHasPermission
export const hasPermission = suite.hasPermission
